var cilTextDirectionLtr = ["512 512", "<polygon fill='var(--ci-primary-color, currentColor)' points='388.687 355.313 433.373 400 24 400 24 432 433.373 432 388.687 476.687 411.313 499.313 494.627 416 411.313 332.687 388.687 355.313' class='ci-primary'/><path fill='var(--ci-primary-color, currentColor)' d='M304,368V72h56V40H172a100,100,0,0,0,0,200h36V368ZM240,72h32V336H240ZM172,208a68,68,0,0,1,0-136h36V208Z' class='ci-primary'/>"];

export { cilTextDirectionLtr };

